import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';
import { IChatThread } from 'app/@chat/domain';
import { ChatThreadService } from 'app/@chat/services/chat-thread.service';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Component({
  selector: 'ngx-chat-app',
  templateUrl: './chat-app.component.html',
  styleUrls: ['./chat-app.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatAppComponent implements OnInit {
  
  currentThread: IChatThread;
  //showChatWindow: boolean = false;

  // @Input("isActive")
  // isActive: boolean = true;

  threadSearch: Subject<string> = new BehaviorSubject('');

  get currentThreadSubject() {
    return this.chatThreadService.onCurrentThreadChange;
  }

  @Output("onClose")
  onClose: EventEmitter<void> = new EventEmitter();

  constructor(private chatThreadService: ChatThreadService) {}

  ngOnInit(): void {
    this.chatThreadService.onCurrentThreadChange.subscribe({
      next: (thread) => {
        this.currentThread = thread;
      }
    });
  }

  

  onCurrentThreadChanged(thread: IChatThread) {
    //this.showChatWindow = true;
    this.chatThreadService.currentThread = thread;
  }

  onSearchValueChanged(event) {
    this.threadSearch.next(event.target.value);
  }

  closeChatWindow() {
    this.chatThreadService.currentThread = null;
  }
}
